import { SkillHelper } from "../../../generalSettings/skills/skillsHelper.js";
import { TreeNodeVm } from "../../../generalSettings/skills/skillsInterfaces.js";
import { ComponentHelper } from "../../util/componentHelper.js";
import { Helper } from "../../util/helper.js";
import { CheckBox } from "../checkBox.js";
import { DatePicker } from "../datePicker.js";
import { FieldInstance } from "../field.js";
import Skills, { SkillsProps } from "../skills.js";
import { MatrixParams } from "./skillsMatrix.js";
import React from "react";
export class ResourceSearchSkills extends React.Component<{
    queryParameters: any,
    isWindow: boolean;
    initialFilter: MatrixParams;
    onFilterChanged: (filter: MatrixParams, triggerSearch: boolean) => void;
}, {
    treeData?: TreeNodeVm[];
    isFilterActive: boolean;
    isAssignment: boolean;
    filter: MatrixParams;
}> {
    private _entity = { Ressnr: null, IsNew: true, RecordRight: { CanRead: true, CanWrite: true, CanReadSkills: true, CanWriteSkills: true, CanChangeSkillprofile: true }, IsWatchable: false, IsWatched: false };

    constructor(props) {
        super(props);
        this.state = {
            treeData: null,
            isFilterActive: false,
            isAssignment: Helper.hasValue(this.props.queryParameters.projnr) && Helper.hasValue(this.props.queryParameters.pindex),
            filter: this.props.initialFilter
        }
    }

    public getSkillsJSON = () => {
        if (!Helper.hasValue(this.state.treeData))
            return null;
        let skills = SkillHelper.getAllSkillCategories(this.state.treeData);
        let result = JSON.stringify(skills);
        return result;
    }

    private onTreeDataLoaded = (data: TreeNodeVm[]) => {
        this.setState({ treeData: data }, () => {
            if (SkillHelper.getFilledSkills(this.state.treeData).length > 0) {
                this.setStateFilter("RequiredSkills", SkillHelper.getFilledSkills(this.state.treeData), true);
            }
        });
    }

    private onTreeDataChanged = (data: TreeNodeVm[]) => {
        this.setStateFilter("RequiredSkills", SkillHelper.getFilledSkills(data));
    }

    private getDatePickerProps = (value: Date, onChange: (value) => void) => {
        const props = ComponentHelper.createFactory().getDefaultDatePickerProps();
        props.field.clearTime = true;
        props.value = value;
        props.onChange = (_, value: string) => { onChange(value) };
        props.disabled = !this.state.filter.IsAvailibilityFilterActive;
        return props;
    }

    private getDatePicker(value: Date, onChange: (value) => void, label: string) {
        const datePickerProps = this.getDatePickerProps(value, onChange);
        return <FieldInstance noHover={true} label={label} >
            <DatePicker {...datePickerProps} />
        </FieldInstance>;
    }

    private setStateFilter = (name: string, value: any, triggerSearch?: boolean) => {
        let matrixParams = this.state.filter;
        matrixParams[name] = value;
        this.setState({ filter: matrixParams }, () => {
            this.props.onFilterChanged(matrixParams, triggerSearch ?? false);
        })
    }

    render() {
        const props: SkillsProps = {
            queryParameters: this.props.queryParameters,
            entity: this._entity,
            onChange: () => { },
            isWindow: this.props.isWindow,
            runningContext: "assignment",
            isResourceSearch: true,
            useSkillProfile: true,
            dynamicSearch: true,
            other: [{ name: "maxEndDate", value: new Date() }]
        };
        return (
            <div className="flex-container">
                <CheckBox
                    field={{ model: "", type: "checkBox", labelAndControlCombined: true, name: Helper.getTranslation("Skills.OnlyMatchRequirement") }}
                    value={this.state.filter.MatchAllRequirementsActive}
                    onChange={(_, value) => this.setStateFilter("MatchAllRequirementsActive", value)}
                />
                <CheckBox
                    field={{ model: "", type: "checkBox", labelAndControlCombined: true, name: Helper.getTranslation("Skills.CheckAvailibilityPeriod") }}
                    value={this.state.filter.IsAvailibilityFilterActive}
                    onChange={(_, value) => this.setStateFilter("IsAvailibilityFilterActive", value)}
                />
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    {!this.state.filter.AssignmentGuids ? this.getDatePicker(this.state.filter.Start, (value) => this.setStateFilter("Start", value), Helper.getTranslation("Auftrag.Start")) : null}
                    {!this.state.filter.AssignmentGuids ? this.getDatePicker(this.state.filter.End, (value) => this.setStateFilter("End", value), Helper.getTranslation("Auftrag.Ende")) : null}
                    {this.state.filter.AssignmentGuids ? <label style={{ padding: "5px" }}>{
                        this.state.filter.AssignmentGuids.length == 1 ? Helper.getTranslation("Einsatz.ConsiderAssignmentPeriod") : Helper.getTranslation("Einsatz.ConsiderAssignmentsPeriods")
                    }</label> : null}
                </div>
                <Skills {...props} onTreeDataLoaded={this.onTreeDataLoaded} onTreeDataChanged={this.onTreeDataChanged} />
            </div>
        );
    }
}